var styles = {"box":"Sessions_box_50wox_1","table":"Sessions_table_50wox_7","load-more":"Sessions_load-more_50wox_12","title":"Sessions_title_50wox_20","sessions-col":"Sessions_sessions-col_50wox_31","device-col":"Sessions_device-col_50wox_44"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
